// actions
import audienceId from '@/store/actions/audienceId'
import slideOptions from '@/store/actions/slideOptions'
import slides from '@/store/actions/slides'
import presentation from '@/store/actions/presentation'
import currentUser from '@/store/actions/currentUser'
import privateFeedback from '@/store/actions/privateFeedback'
import attendedPresentation from '@/store/actions/attendedPresentation'
import common from '@/store/actions/common'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...presentation,
  ...currentUser,
  ...privateFeedback,
  ...attendedPresentation,
  ...common,

  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },

  setSlide: ({ commit }, payload) => {
    if (!payload) return

    commit('setSlide', payload)
    commit('setSlideV2', payload)
  },

  // Update Presentation
  updateSlide: (context, payload) => {
    context.commit('updateSlide', payload)
    context.commit('updateSlideV2', payload)
  },

  // Update Presentation
  setConnectionError: (context, payload) => {
    context.commit('setConnectionError', payload)
  },

  setUserLoaded: (context, payload) => {
    context.commit('setUserLoaded', payload)
  },

  setIsLoadingCurrentUserAction: (context, payload) => {
    context.commit('setIsLoadingCurrentUser', payload)
  },
}
